import Swal from "sweetalert2";
import { clearMemory, processRequest, setError, setIngresos, setListOrders } from "./slice";
import { URL_API } from "../../../../../app/apiConnection";

export const getIngresosPeriodo = (dateBegin, dateEnd, period) => {
    return async (dispatch, getState) => {
        dispatch(clearMemory());
        dispatch(processRequest());
        await URL_API.get(`/Reportes/getReportIngresosForPeriod/${dateBegin}/${dateEnd}/${period}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                dispatch(setIngresos({
                    msg: response.data.msg,
                    dateStart: response.data.fFinal,
                    dateEnd: response.data.fInicio,
                    ingresos: response.data.data
                }))
            }
            if (response.data.success == false) {
                Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });
            }

        }).catch(function (error) {
            // console.log(error.response.data);

            Swal.fire({
                icon: "warning",
                title: "Atencion...",
                text: error.response.data.msg,
                customClass: {
                    confirmButton: 'btn btn-primary',  // rojo
                    cancelButton: 'btn btn-secondary' // gris
                },
            });
            dispatch(setError({
                msg: error.response.data.msg
            }))
        });
    }
}
export const getReportListForCommisions = (
  dateBegin,
  dateEnd,
  idEmployee,
  cc,
  tipoEmpleado
) => {
  return async (dispatch, getState) => {
    dispatch(clearMemory());
    dispatch(processRequest());
    // ultimo parametro limit

    await URL_API.get(
      `/Reports/getReportCommisions/${dateBegin}/${dateEnd}/${idEmployee}/${cc}/${tipoEmpleado}`
    )
      .then(function (response) {
        // console.log(response.data);
        if (response.data.status == 200) {
          dispatch(
            setListOrders({
              msg: response.data.msg,
              rows: response.data.rows,
              dateStart: response.data.fFinal,
              dateEnd: response.data.fInicio,
              orders: response.data.data,
            })
          );
        }        
      })
      .catch(function (error) {
        console.log(error);

        Swal.fire({
          icon: "warning",
          title: "Atencion...",
          text: 'No se encontro informacion, con los parametros ingresados',
          customClass: {
            confirmButton: "btn btn-primary", // rojo
            cancelButton: "btn btn-secondary", // gris
          },
        });

        dispatch(
          setError({
            msg: error.response.data.msg,
          })
        );
      });
  };
};






